import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Block, Text, Button } from '$views/components'

interface Props {
  presentationMessage: string
  name: string
  onClose: () => void
  onClickPrimaryButton: () => void
}

export const PresentationMessageModal: React.FC<Props> = ({
  presentationMessage,
  name,
  onClose,
  onClickPrimaryButton,
}) => {
  return (
    <ModalWindow onClose={onClose}>
      <Block>
        <Text title as="span">
          Mensaje de{' '}
        </Text>
        <Text title capitalize as="span">
          {name}
        </Text>
      </Block>
      <Text italic marginTop="base" marginBottom="medium">{`"${presentationMessage}"`}</Text>
      <Button primary onClick={onClickPrimaryButton}>
        ¡Gracias!
      </Button>
      <Block marginTop="base" marginBottom="small">
        <Text menu color="menu">
          Desde aquí puedes agradecer a{' '}
          <Text capitalize menu color="menu" as="span">
            {name}
          </Text>{' '}
          por su mensaje de presentación personal para ti o empezar a conoceros mejor. 💛💛
        </Text>
      </Block>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/PresentationMessageModal.tsx